// nginx trả 403 khi URL dài quá 330 ký tự, chừa chỗ cho "/tim-kiem.html?q=" và "&page=..."
const MAX_ENCODED_LENGTH = 250
const STORAGE_KEY = 'search_full_query'
const FORM_SELECTOR = 'form[action="/tim-kiem.html"]'

// Độ dài khi trình duyệt submit form: dấu cách thành "+" (1 ký tự)
const encodedLength = (str) => encodeURIComponent(str).replace(/%20/g, '+').length

const shorten = (query) => {
  let words = query.split(/\s+/)
  while (words.length > 1 && encodedLength(words.join(' ')) > MAX_ENCODED_LENGTH) {
    words.pop()
  }
  // Một từ liền quá dài thì cắt theo ký tự
  let chars = Array.from(words.join(' '))
  while (encodedLength(chars.join('')) > MAX_ENCODED_LENGTH) {
    chars.pop()
  }
  return chars.join('')
}

const storage = {
  get() {
    try {
      return sessionStorage.getItem(STORAGE_KEY)
    } catch (error) {
      return null
    }
  },
  set(value) {
    try {
      sessionStorage.setItem(STORAGE_KEY, value)
    } catch (error) {}
  },
  remove() {
    try {
      sessionStorage.removeItem(STORAGE_KEY)
    } catch (error) {}
  },
}

const shortenOnSubmit = () => {
  document.querySelectorAll(FORM_SELECTOR).forEach((form) => {
    form.addEventListener('submit', () => {
      let input = form.querySelector('input[name="q"]')
      if (!input) return
      let query = input.value.trim()
      let shortQuery = shorten(query)
      if (shortQuery === query) {
        storage.remove()
        return
      }
      storage.set(query)
      input.value = shortQuery
    })
  })
}

// Trên trang kết quả: điền lại từ khóa, ưu tiên câu đầy đủ nếu trước đó bị cắt
const fillQuery = () => {
  if (window.location.pathname !== '/tim-kiem.html') return
  let query = new URLSearchParams(window.location.search).get('q')
  if (query === null) return
  let fullQuery = storage.get()
  storage.remove()
  let value = fullQuery && fullQuery !== query && fullQuery.startsWith(query) ? fullQuery : query
  document.querySelectorAll(`${FORM_SELECTOR} input[name="q"]`).forEach((input) => {
    input.value = value
  })
}

export default function searchQuery() {
  try {
    shortenOnSubmit()
    fillQuery()
  } catch (error) {
    console.log('searchQuery', { message: error.message })
  }
}
